module.exports = {
  label: {
    headerTitle: 'Question',
    AddheaderTitle: 'Add Question',
    EditheaderTitle: 'Edit Question',
    code: 'Code',
    queastion: 'Question',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel'
    }
  }
}